import ApiClient from '@/api/ApiClient';
import { DOCUMENT_TYPE } from '@/typings/enums/DOCUMENT_TYPE';

const client = new ApiClient('agency/mail');

class MailApiAgency {

	static async sendToTempWorkers (userIds: number[], bccUserIds: number[], object: string, content: string) {
		return client.post<void>('tempWorker', {
			userIds,
			bccUserIds,
			mailObject: object,
			content,
		});
	}

	static async sendToClients (
		clientCompanyIds: number[],
		bccUserIds: number[],
		documentType: DOCUMENT_TYPE,
		documentIds: number[],
		object: string,
		content: string) {

		return client.post('client', {
			clientCompanyIds,
			bccUserIds,
			documentType,
			documentIds,
			mailObject: object,
			content,
		});
	}
}

export default MailApiAgency;
